<template>
  <vx-card>
    <vs-prompt
      title="Export To Excel"
      class="export-options"
      @cancle="clearFields"
      @accept="exportToExcel"
      accept-text="Export"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">Cell Auto Width:</span>
        <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
      </div>
    </vs-prompt>

    <vs-prompt title="Payment Detail" :active.sync="paymentDetailPrompt" :buttons-hidden="true">
      <vx-card
        content-color="#fff"
        card-background="linear-gradient(120deg, #7f7fd5, #86a8e7, #91eae4)"
      >
        <!-- <p class="mb-3">
          <strong>Reference Number:</strong>
          {{details['reference_number']}}
        </p>-->
        <p class="mb-3">
          <strong>Payment Reference</strong>
          {{ details["payment_reference"] }}
        </p>
        <p class="mb-3">
          <strong>Food Cost</strong>
          {{ details["food_cost"] }}
        </p>
        <p class="mb-3">
          <strong>Taxi Cost</strong>
          {{ details["taxi_cost"] }}
        </p>
        <p class="mb-3">
          <strong>Booking Status</strong>
          {{
          details["delivery_booking"]
          ? details["delivery_booking"].booking_id == null
          ? "Not started"
          : "Processed"
          : ""
          }}
        </p>
      </vx-card>
    </vs-prompt>

    <div class="export-table">
      <div class="flex justify-end">
        <datepicker :disabledDates="disabledDates" placeholder="From Date" v-model="dateFrom"></datepicker>&nbsp;&nbsp;
        <datepicker :disabledDates="disabledDates" placeholder="To Date" v-model="dateTo"></datepicker>&nbsp;&nbsp;
        <vs-button @click="filterPayments">Filter</vs-button>&nbsp;&nbsp;
        <vs-button @click="clearDateFilter">Clear</vs-button>
      </div>

      <vs-table :data="payments" v-model="selectedPayments" multiple search>
        <template slot="header">
          <vs-button @click="activePrompt = true">Export</vs-button>
          <vs-spacer />
          <div class="pre-balance flex justify-end">
            <p class="font-semibold text-warning">Previous Balance : {{ preBalance }}</p>
          </div>
        </template>
        <template slot="thead">
          <vs-th>Date</vs-th>
          <vs-th>Payment Reference</vs-th>
          <vs-th>Status</vs-th>
          <vs-th>Debit</vs-th>
          <vs-th>Credit</vs-th>
          <vs-th>Balance</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ data[indextr].created_at }}</vs-td>
            <vs-td>{{ data[indextr].payment_reference }}</vs-td>
            <vs-td>{{ data[indextr].status }}</vs-td>
            <vs-td>
              {{
              data[indextr].payment_type == "debit" ? data[indextr].amount * -1 : ""
              }}
            </vs-td>
            <vs-td>
              {{
              data[indextr].payment_type == "credit" ? data[indextr].amount : ""
              }}
            </vs-td>
            <vs-td>{{ data[indextr].balance }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <vx-tooltip
                v-if="data[indextr].payment_type == 'credit'"
                color="primary"
                text="Credit Payment Details"
              >
                <feather-icon
                  icon="EyeIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="showData(tr.payment_reference)"
                />
              </vx-tooltip>
              <vx-tooltip v-else color="primary" text="No Detail Debit">
                <feather-icon
                  icon="EyeOffIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  :disabled="true"
                />
              </vx-tooltip>
              <!-- <feather-icon icon="PlusIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="showData(tr.id)" /> -->
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <div class="flex justify-end">
        <p
          class="font-semibold text-success"
        >Current Balance : {{ $store.state.company.wallet_amount }}</p>
      </div>
    </div>
  </vx-card>
</template>
<script>
import { _listPayments } from "@/services/Company";
import { _detailPayment, _filterPayments } from "@/services/Payment";
import vSelect from "vue-select";

import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
    vSelect
  },
  data() {
    return {
      disabledDates: {
        to: new Date(new Date().getFullYear(), new Date().getMonth() - 2), // Disable all dates up to specific date
        from: new Date() // Disable all dates after specific date
      },
      dateFrom: null,
      dateTo: null,
      payments: [],
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "csv",
      headerTitle: [
        "Date",
        "Payment Reference",
        "Status",
        "Debit",
        "Credit",
        "Balance"
      ],
      headerVal: [
        "created_at",
        "payment_reference",
        "status",
        "debit_amount",
        "amount",
        "balance"
      ],
      selectedPayments: [],
      activePrompt: false,
      paymentDetailPrompt: false,
      details: [],
      preBalance: 0
    };
  },
  beforeMount() {
    this.getPayments();
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.companyID = val;
      this.getPayments();
    }
  },
  methods: {
    getPayments() {
      this.$vs.loading();
      _listPayments(this.$store.state.company.companyID)
        .then(response => {
          this.$vs.loading.close();
          this.payments = response.data.obj.list;
          if (this.payments.length) {
            this.$store.dispatch("company/updateCompanyWallet", {
              wallet_amount: this.payments[this.payments.length - 1].balance
            });
            if (this.payments[0].status === "paid") {
              this.preBalance =
                this.payments[0].balance - this.payments[0].amount;
            } else {
              this.preBalance = this.payments[0].balance;
            }
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger"
          });
        });
    },
    exportToExcel() {
      import("@/vendor/Export2Excel").then(excel => {
        const list = this.selectedPayments;
        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        });
        this.clearFields();
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          // Add col name which needs to be translated
          if (j === "amount") {
            if (v["payment_type"] === "credit") return v[j];
            return "";
          } else if (j === "debit_amount") {
            if (v["payment_type"] === "debit") return v.amount * -1;
            return "";
          } else {
            return v[j];
          }
        })
      );
    },
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "csv";
    },
    showData(data) {
      _detailPayment(data)
        .then(res => {
          this.paymentDetailPrompt = true;
          this.details = res.data.obj.payment;
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger"
          });
        });
    },
    filterPayments() {
      if (!this.dateFrom) {
        return alert("select some date to filter");
      }
      if (!this.dateTo) {
        this.dateTo = new Date();
      }

      const data = {
        from: moment(this.dateFrom)
          .startOf("day")
          .format("YYYY-MM-DD 00:00:00"),
        to: moment(this.dateTo)
          .endOf("day")
          .format("YYYY-MM-DD 23:59:59"),
        company_id: this.$store.state.company.companyID
      };
      _filterPayments(data)
        .then(res => {
          this.payments = res.data.obj.list;
          if (this.payments.length) {
            if (this.payments[0].status === "paid") {
              this.preBalance =
                this.payments[0].balance - this.payments[0].amount;
            } else {
              this.preBalance = this.payments[0].balance;
            }
          }
        })
        .catch(error => {
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger"
          });
        });
    },
    clearDateFilter() {
      this.dateTo = null;
      this.dateFrom = null;
      this.getPayments();
    }
  }
};
</script>
<style lang="css">
.pre-balance {
  margin-top: 5.5rem;
  margin-right: -14rem;
}
</style>
